var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"z-virtual-scroll"},[_c('div',{ref:"viewport",staticClass:"viewport",style:({ 
      width: _vm.width ? `${ _vm.width }px` : '100%',
      height: _vm.height ? `${ _vm.height }px` : '100%' 
    }),on:{"scroll":_vm.onScroll}},[_c('div',{staticClass:"list-phantom",style:({ height: `${ _vm.phantomHeight }px` })}),_c('div',{staticClass:"list-area",style:({
        transform: `translateY(${ _vm.startOffset }px)`
      })},[_vm._l((_vm.items),function(item,index){return [(_vm.isBetweenViewRanges(index))?_c('div',{key:index,style:({ height: `${ _vm.itemHeight }px` })},[_vm._t("default",null,{"index":index,"item":item})],2):_vm._e()]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }